import T from 'prop-types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useAsyncFn } from 'react-use';

import { alertError, alertSuccess, alertWarning } from '../../redux/actions';
import { client } from '../../utilities/api';
import { captureError } from '../../utilities/error';
import { useRedirect } from '../../hooks/useRedirect';
import routes from '../../routes/constants';

const updateRequestAccess = (projectId, userId, status) => async () => {
  const resp = await client.updateRequestAccess(projectId, userId, status);
  return resp;
};

const UpdateBookmarkPage = ({ status }) => {
  const redirect = useRedirect();
  const dispatch = useDispatch();
  const { projectId, userId: _userId } = useParams();
  const userId = _userId ? parseInt(_userId, 10) : null;
  const [state, update] = useAsyncFn(
    updateRequestAccess(projectId, userId, status),
    [projectId, userId, status]
  );

  useEffect(() => {
    (async () => {
      const resp = await update();
      // was successful
      if (resp.data) {
        const redirectUrl = resp.data?.bookmark?.redirect_url;
        if (redirectUrl) {
          redirect.push(redirectUrl);
        } else {
          redirect.push(routes.dashboard);
        }
        dispatch(alertSuccess('Access updated successfully'));
      }
    })();
  }, [dispatch, redirect, update]);

  useEffect(() => {
    const err = state.error;
    if (err) {
      if (err.response?.data?.statusCode === 409) {
        dispatch(alertWarning(err.response.data.message));
      } else {
        dispatch(alertError(err.response?.data?.message ?? err.message));
        captureError(err);
      }
    }
  }, [dispatch, state.error]);

  return null;
};

UpdateBookmarkPage.propTypes = {
  status: T.oneOf(['accepted', 'rejected']),
};

export default UpdateBookmarkPage;
